function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var PurchaseMonitorTemplate = require('./purchase-monitor.template');
var STAGES = {
  preparing: {
    title: 'Preparing purchase',
    detail: 'Getting ready…'
  },
  checking_wallet: {
    title: 'Checking wallet',
    detail: 'Confirming your balance…'
  },
  creating: {
    title: 'Creating transaction',
    detail: 'Building and signing your payment…'
  },
  sending: {
    title: 'Sending transaction',
    detail: 'Broadcasting to the network…'
  }
};
function escapeHtml() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/**
 * Covers the gap between Buy click and Transaction Monitor:
 * balance check, purchase tx construction/signing, and broadcast.
 * Instantiated once on Store (mod.purchase_monitor).
 */
var PurchaseMonitor = /*#__PURE__*/function () {
  function PurchaseMonitor(app, mod) {
    _classCallCheck(this, PurchaseMonitor);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, true, true, false);
    this.overlay["class"] = 'saito-overlay store-purchase-overlay-shell';
    this.overlay.clickBackdropToClose = false;
    this.overlay.nonBlocking = false;
    this.active = false;
    this.stage = null;
    this.listingTitle = '';
  }

  /**
   * Open preparation UI. Replaces listing-detail as the active blocking surface.
   */
  return _createClass(PurchaseMonitor, [{
    key: "show",
    value: function show() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$listingTitle = _ref.listingTitle,
        listingTitle = _ref$listingTitle === void 0 ? '' : _ref$listingTitle;
      this.listingTitle = String(listingTitle || '').trim();
      this.active = true;
      this.stage = 'preparing';
      var stage = STAGES.preparing;
      this._showHtml(PurchaseMonitorTemplate.panel({
        listingTitle: escapeHtml(this.listingTitle),
        stageTitle: escapeHtml(stage.title),
        stageDetail: escapeHtml(stage.detail)
      }));
    }

    /**
     * Update the visible stage label. No-op if not active.
     * @param {keyof typeof STAGES} stageKey
     */
  }, {
    key: "setStage",
    value: function setStage() {
      var stageKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'preparing';
      if (!this.active) {
        return;
      }
      var stage = STAGES[stageKey] || STAGES.preparing;
      this.stage = stageKey;
      var titleEl = document.querySelector("#saito-overlay".concat(this.overlay.ordinal, " [data-monitor-stage-title]"));
      var detailEl = document.querySelector("#saito-overlay".concat(this.overlay.ordinal, " [data-monitor-stage-detail]"));
      if (titleEl) {
        titleEl.textContent = stage.title;
      }
      if (detailEl) {
        detailEl.textContent = stage.detail;
      }

      // Overlay not in DOM yet — re-show with current stage.
      if (!titleEl && this.active) {
        this._showHtml(PurchaseMonitorTemplate.panel({
          listingTitle: escapeHtml(this.listingTitle),
          stageTitle: escapeHtml(stage.title),
          stageDetail: escapeHtml(stage.detail)
        }));
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      var _document$querySelect;
      if (!this.active && !this.overlay.visible) {
        return;
      }
      this.active = false;
      this.stage = null;
      this.overlay.close();
      (_document$querySelect = document.querySelector('.saito-container')) === null || _document$querySelect === void 0 || _document$querySelect.classList.remove('store-purchase-modal-open');
    }
  }, {
    key: "_showHtml",
    value: function _showHtml(html) {
      var _this = this;
      var container = document.querySelector('.saito-container');
      container === null || container === void 0 || container.classList.add('store-purchase-modal-open');
      this.overlay.show(html, function () {
        _this.onOverlayClosed();
      });
      this.applyOverlayLayout();
    }
  }, {
    key: "onOverlayClosed",
    value: function onOverlayClosed() {
      var _document$querySelect2;
      this.active = false;
      this.stage = null;
      (_document$querySelect2 = document.querySelector('.saito-container')) === null || _document$querySelect2 === void 0 || _document$querySelect2.classList.remove('store-purchase-modal-open');
    }
  }, {
    key: "applyOverlayLayout",
    value: function applyOverlayLayout() {
      var el = document.getElementById("saito-overlay".concat(this.overlay.ordinal));
      if (el) {
        el.classList.add('store-purchase-overlay-shell', 'maximized-overlay');
      }
      var backdrop = document.getElementById("saito-overlay-backdrop".concat(this.overlay.ordinal));
      if (backdrop) {
        backdrop.classList.add('store-purchase-overlay-backdrop');
      }
    }
  }]);
}();
PurchaseMonitor.STAGES = STAGES;
module.exports = PurchaseMonitor;